<template>
  <div class="">
    <b-card class="no-border animated fadeIn">
      <b-table striped :items="table.items" :fields="table.fields">
        <template #cell(file_name)="data">
          <router-link :to="`/report/files/${data.item.job_id}`">{{ data.value }}</router-link>
        </template>
        <template #cell(report_name)="data">
          <span v-if="data.item.report">
            <i class="fa" :class="data.item.report.iconClass" aria-hidden="true"></i> {{ data.item.report.title }}
          </span>
        </template>
        <template #cell(action)="data">
          <a :href="data.item.file_url" class="text-success" title="Download" download>
            <i class="fa fa-download" aria-hidden="true"></i> Download
          </a>
          &nbsp;&nbsp;
          <a href="#" @click.prevent="deleteFile(data.item)" title="Remove" class="text-danger" download>
            <i class="fa fa-times" aria-hidden="true"></i> Remove
          </a>
        </template>
        <template #cell(created_at)="data">
          <span :title="formatDateTime(data.value)">{{ formatDateDistance(data.value) }}</span>
        </template>
        <template #cell(format)="data">
          <span v-if="data.value === 'XLSX' || data.value === null"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel</span>
          <span v-else-if="data.value === 'PDF'"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> PDF</span>
          <span v-else-if="data.value === 'CSV'"><i class="fa fa-file-code-o" aria-hidden="true"></i> CSV</span>
        </template>
      </b-table>
      <hr>
      <b-pagination class="mt-3" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="pageCount" v-if="loaded && table.items.length !== 0"></b-pagination>
      <b-alert show v-if="loaded && table.items.length === 0">There's no exported reports.</b-alert>
    </b-card>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';

export default {
  name: 'exported_report',
  mixins: [dateMixin],
  data() {
    return {
      loaded: false,
      table: {
        fields: ['file_name', 'report_name', 'format', 'created_at', 'action'],
        items: [],
      },
      currentPage: 1,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'report/files', name: 'Report Files' },
    ]);
    this.$store.dispatch('report_files/LOAD_INFO_DATA');
    this.$store.dispatch('report_files/LOAD_DATA').then(() => {
      this.loaded = true;
      this.currentPage = this.curPage;
    });
  },
  computed: {
    files() {
      return this.$store.getters['report_files/files'];
    },
    totalRows() {
      return this.$store.getters['report_files/files_info'];
    },
    pageCount() {
      return this.$store.getters['report_files/page_count'];
    },
    curPage() {
      return this.$store.getters['report_files/page_number'];
    },
  },
  watch: {
    files(data) {
      this.table.items = data;
    },
    currentPage(newValue) {
      this.$store.commit('report_files/SET_QUERY_PAGE', newValue);
      this.loadData();
    },
  },
  methods: {
    deleteFile(report) {
      this.$store.dispatch('report_files/DELETE_FILE', report.file_name);
    },
    loadData() {
      this.loaded = false;
      this.$store.dispatch('report_files/LOAD_DATA').then(() => {
        this.loaded = true;
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/pages/report/files/Index.vue